import { combineReducers } from "redux";
import generalData from "./general-data-reducer";
import headerFilerToggle from './toggle-header-filter-reducer';

export default combineReducers({
    generalData: generalData,
    headerFilerToggle: headerFilerToggle
})